import qs from 'qs'

import { APIParams } from '../../electron/typings/api'

const query = qs.parse(
  window.location.search.substring(1, window.location.search.length) ||
    window.location.hash?.split('?')?.[1]
)
const { ipcRenderer } = window?.require?.('electron') || {}
export const PARAMS = (eventName: string, data?: any): APIParams => {
  const route: any = query.route?.toString() || ''
  console.log('electronapi', route, query)
  return {
    eventName,
    route: route,
    data: data,
    requestTime: Math.floor(new Date().getTime() / 1000),
  }
}
export const api = {
  openDevTools() {
    ipcRenderer?.send?.('openDevTools', PARAMS('openDevTools'))
  },
  getMode() {
    ipcRenderer?.send?.('getMode', PARAMS('getMode'))
  },
  async showNotification(params: {
    title: string
    content: string
    timeout: number
  }) {
    // 1. 检测是否在 Electron 环境
    const isElectron = !!(
      window &&
      window.process &&
      (window.process as any).type
    )

    if (isElectron && ipcRenderer?.send) {
      // 原有的 Electron 逻辑
      ipcRenderer.send(
        'showNotification',
        PARAMS('showNotification', {
          title: params.title,
          content: params.content,
          timeout: params.timeout,
        })
      )
    } else if ('Notification' in window) {
      // 2. Web 端原生通知逻辑
      // 检查权限，如果没有权限则请求权限

      let permission = Notification.permission
      if (permission === 'default') {
        permission = await Notification.requestPermission()
      }
      console.log('showNotification', permission)

      if (permission === 'granted') {
        const notification = new Notification(params.title, {
          body: params.content,
          // Web 端可以在这里加小图标，比如你的喵喵 Logo
          // icon: '/logo.png'
        })

        // 处理 Web 端的超时关闭
        if (params.timeout > 0) {
          setTimeout(() => notification.close(), params.timeout)
        }
      }
    } else {
      console.warn('当前浏览器不支持桌面通知')
    }
  },
  setMode(mode: 'system' | 'dark' | 'black' | 'light') {
    ipcRenderer?.send?.(
      'setMode',
      PARAMS('getMode', {
        mode,
      })
    )
  },
  openMainProgram() {
    ipcRenderer?.send?.('openMainProgram', PARAMS('openMainProgram', {}))
  },
  hideWindow() {
    ipcRenderer?.send?.('hideWindow', PARAMS('hideWindow', {}))
  },
  updateData() {
    ipcRenderer?.send?.('updateData', PARAMS('updateData', {}))
  },
  updateProfile() {
    ipcRenderer?.send?.('updateProfile', PARAMS('updateProfile', {}))
  },
  updateSetting({ type }: { type: string }) {
    ipcRenderer?.send?.(
      'updateSetting',
      PARAMS('updateSetting', {
        type,
      })
    )
  },
  saveAs(
    fileName: string,
    file: string,
    options: {
      extensions: string[]
    }
  ) {
    ipcRenderer?.send?.(
      'saveAs',
      PARAMS('saveAs', {
        fileName,
        file,
        options,
      })
    )
  },
  openFolder(lastFolderPath: string, type: 'BackupPath') {
    ipcRenderer?.send?.(
      'openFolder',
      PARAMS('openFolder', {
        lastFolderPath,
        type,
      })
    )
  },
  backup(backupNow: boolean = false) {
    ipcRenderer?.send?.(
      'backup',
      PARAMS('backup', {
        backupNow,
      })
    )
  },
}

export default {
  api,
}
